import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=17c5505f&scoped=true"
import script from "./serviceFee.vue?vue&type=script&lang=js"
export * from "./serviceFee.vue?vue&type=script&lang=js"
import style0 from "./serviceFee.vue?vue&type=style&index=0&id=17c5505f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c5505f",
  null
  
)

export default component.exports